import { render } from "./Discount.vue?vue&type=template&id=e6b174e2&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"

import "./Discount.vue?vue&type=style&index=0&id=e6b174e2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e6b174e2"

export default script